<template>
  <div class="domain-authenticate-form">
    <v-stepper
      class="domain-authenticate-form-steps"
      v-model="currentStep"
      alt-labels
      @input="emitStep"
    >
      <v-stepper-header>
        <v-stepper-step
          :step="1"
          editable
          :complete="currentStep > 1"
          :edit-icon="$vuetify.icons.complete"
        >
          {{ $t("message.email.message.domain") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :step="2" :complete="currentStep > 2">
          {{ $t("message.email.message.validate") }}
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <domain-authenticate-form-domain @submit="onDomainSubmit" />
        </v-stepper-content>

        <v-stepper-content step="2">
          <domain-authenticate-form-validate
            v-if="domain"
            :domain="domain"
            @validated="emitValidated"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import DomainAuthenticateFormDomain from "@components/modules/domain/authenticate/form/domain/DomainAuthenticateFormDomain";
import DomainAuthenticateFormValidate from "@components/modules/domain/authenticate/form/validate/DomainAuthenticateFormValidate";

export default {
  components: {
    DomainAuthenticateFormDomain,
    DomainAuthenticateFormValidate,
  },

  data() {
    return {
      currentStep: 0,
      domain: undefined,
    };
  },

  props: {},

  created() {},

  computed: {},

  watch: {},

  methods: {
    setDomainVal(value) {
      this.domain = value;
    },
    onDomainSubmit(value) {
      this.setDomainVal(value);
      this.incrementStep();
    },
    incrementStep() {
      this.currentStep++;
    },
    emitStep(val) {
      this.$emit("step", val);
    },
    emitValidated(isValid) {
      this.$emit("validated", isValid);
    },
  },
};
</script>

<style lang="scss" scoped>
.domain-authenticate-form {
  .domain-authenticate-form-steps {
    box-shadow: none;

    .v-stepper__step {
      padding: 0;
    }

    .v-divider {
      margin-top: 12px;
    }
  }
}
</style>
